import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
    const sessionValid = useSelector(state => state.config?.sessionValid);

    console.log("sessionValid:", sessionValid);


    // For all other protected routes, check session validity
    return sessionValid ? children : <Navigate to="/" replace />;
};

export default PrivateRoute;
